var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56718 2.91569C9.7273 2.53071 10.2727 2.53071 10.4328 2.91569L12.2044 7.17524C12.2719 7.33753 12.4246 7.44843 12.5998 7.46247L17.1983 7.83114C17.6139 7.86446 17.7825 8.38313 17.4658 8.65438L13.9622 11.6556C13.8287 11.7699 13.7704 11.9494 13.8112 12.1203L14.8816 16.6077C14.9784 17.0133 14.5371 17.3339 14.1813 17.1165L10.2443 14.7118C10.0943 14.6202 9.90565 14.6202 9.75564 14.7118L5.81865 17.1165C5.46283 17.3339 5.02161 17.0133 5.11836 16.6077L6.18877 12.1203C6.22955 11.9494 6.17125 11.7699 6.03776 11.6556L2.53416 8.65438C2.2175 8.38313 2.38602 7.86446 2.80164 7.83114L7.40018 7.46247C7.5754 7.44843 7.72803 7.33753 7.79553 7.17524L9.56718 2.91569Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e23a239bdf312cb8a909f2478bbf6381.svg";
export { ForwardRef as ReactComponent };